import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as T from "utils/types";
import * as API from 'app/public_api';

export const cntPerPage = 10;

const initList = createAsyncThunk(
    'altTrendingTab/initList', 
    async (
        data:{
            facultyID: number,
            departmentID: number,
            sortType: T.altTrendingSortType
        }, 
        thunkAPI
    )=>{
        const {
            facultyID, departmentID, 
            sortType
        } = data;
        const { currentPage }= (thunkAPI.getState() as T.RootState).altTrendingTab;
        return await API.rAltTrendingList(
            currentPage+1,
            departmentID,
            facultyID,
            sortType
        );
    }
)
const loadMore = createAsyncThunk(
    'altTrendingTab/rAltTrendingList', 
    async ( data, thunkAPI
    )=>{
        const {
            facultyID,
            departmentID,
            altTrendingSpecific: { sortType }
        } = (thunkAPI.getState() as T.RootState).searchPgUserInputs;
        const { currentPage }= (thunkAPI.getState() as T.RootState).altTrendingTab;
        return await API.rAltTrendingList(
            currentPage+1,
            departmentID,
            facultyID,
            sortType
        );
    }
)

export const altTrendingThunks = { initList, loadMore };

export const initialState: T.AltTrendingTab = {
    pubList: [],
    currentPage: 0,
    hasNext: true,
    status: 'idle',
    errorMsg: null,
    currentRequestId: null,
}

// publication tab slice
export default createSlice({
    name: 'altTrendingTab',
    initialState,
    reducers: {},
    extraReducers: builder=>{

        // initList thunk (this maybe called by other component, so it has this init steps)
        builder.addCase(initList.pending, (state, action) => {

            state.currentPage = initialState.currentPage;
            state.hasNext = initialState.hasNext;

            state.status = 'loading';
            state.errorMsg = initialState.errorMsg;
            state.currentRequestId = action.meta.requestId;

            // set the list to be cntPerPage skeleton items
            state.pubList = [
                ...new Array(cntPerPage)
            ].map(()=>({loading: true, item: null}));
        });
        builder.addCase(initList.fulfilled, (state, action) => {
            // below line makes sure the response comes from the most recent request
            if(action.meta.requestId===state.currentRequestId){
                state.status = 'succeeded';

                const {links, results} = action.payload            

                state.hasNext = !!links.next;
                state.currentPage += 1;

                // set the list to what we received
                state.pubList = results.map(
                    x=>({loading:false, item: x})
                );

            }
        });
        builder.addCase(initList.rejected, (state, action) => {
            // below line makes sure the response comes from the most recent request
            if(action.meta.requestId===state.currentRequestId){
                state.status = 'failed';
                state.errorMsg = action.error.message;
            }
        });

        // loadMore thunk
        builder.addCase(loadMore.pending, (state, action) => {
            state.status = 'loading';

            // add cntPerPage skeleton items to the list
            state.pubList = state.pubList.concat( 
                [...new Array(cntPerPage)].map(()=>({loading:true, item: null}))
            );
        });
        builder.addCase(loadMore.fulfilled, (state, action) => {
            state.status = 'succeeded';

            const {links, results} = action.payload            

            state.hasNext = !!links.next;
            state.currentPage += 1;

            // replace the last cntPerPage skeleton item list 
            // to the list we received
            state.pubList = state.pubList.slice(0, -cntPerPage).concat( 
                results.map(x=>({loading:false, item: x}))
            );
        });
        builder.addCase(loadMore.rejected, (state, action) => {
            state.status = 'failed';
            state.errorMsg = action.error.message;
        });

    }
});
